import * as _ from "lodash";
import { Components } from "formiojs";

const TextFieldComponent = Components.components.textfield;

export default class MiproClinicianRegistrationNoTextField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproClinicianRegistrationNoTextField",
            label: "Registration No",
            key: "dbo.mipro.miproClinicianRegistrationNo",
            placeholder: "Enter Clinician Registration No.", 
            disabled: false,
            input: true,
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Registration No",
            group: "basic",
            icon: "user-md",
            weight: 70,
            schema: MiproClinicianRegistrationNoTextField.schema(),            
        };
    }
}

Components.addComponent("miproClinicianRegistrationNoTextField", MiproClinicianRegistrationNoTextField);